import React from 'react';
import Tags from './Tags';

interface TagsDropdownProps {
  dropdownOpen: boolean;
  setDropdownOpen: (value: boolean) => void;
  availableTags?: string[];
  addTag: (tag: string) => void;
  patientProfile: any;
  themeStyle: string;
}
const TagsDropdown = ({
  dropdownOpen,
  setDropdownOpen,
  availableTags = [],
  addTag,
  patientProfile,
  themeStyle,
}: TagsDropdownProps) => {
  // const { selectedTenancy } = useSelector(
  //   (state: RootState) => state.clinicianProfile,
  // );
  // const addingTagsDisabled = selectedTenancy?.features?.tags?.disableAdding;
  return (
    <div className="custom-tags">
      <Tags
        open={dropdownOpen}
        patientProfile={patientProfile}
        themeStyle={themeStyle}
      />

      {/* {availableTags.length > 0 && (
        <Dropdown show={dropdownOpen} onToggle={setDropdownOpen}>
          {!addingTagsDisabled && (
            <Dropdown.Toggle id="dropdown-tags">
              <i className="fa-md fa-solid fa-square-plus"></i>
            </Dropdown.Toggle>
          )}
          <Dropdown.Menu>
            {availableTags.map((tag, index) => (
              <Dropdown.Item key={index} onClick={() => addTag(tag)}>
                {tag}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      )} */}
    </div>
  );
};

export default TagsDropdown;
